import { makeStyles } from '@rbx/ui';

const useTrayHeaderStyles = makeStyles()({
  header: {
    paddingLeft: 12,
    paddingRight: 6,
    paddingTop: 12,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  
  markAllAsReadButton: {
    padding: 8
  },

  iconButton: {
    padding: 4
  }
});

export default useTrayHeaderStyles;
